import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "c-showroom-2025__brand-title sr-only" }
const _hoisted_3 = { class: "c-showroom-2025__brand-logo" }
const _hoisted_4 = { class: "c-showroom-2025-cars-types -desktop" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "c-showroom-2025-cars-types -mobile" }
const _hoisted_7 = { class: "o-select__wrap" }
const _hoisted_8 = ["value"]
const _hoisted_9 = { class: "c-showroom-2025-prices-selector__wrap" }
const _hoisted_10 = { class: "c-showroom-2025-prices-selector" }
const _hoisted_11 = { class: "c-showroom-2025-cars-list" }
const _hoisted_12 = { class: "c-showroom-2025-car__img" }
const _hoisted_13 = ["href"]
const _hoisted_14 = ["src", "alt"]
const _hoisted_15 = { class: "c-showroom-2025-car__years" }
const _hoisted_16 = ["href"]
const _hoisted_17 = ["href"]
const _hoisted_18 = { class: "c-showroom-2025-car__info" }
const _hoisted_19 = { class: "c-showroom-2025-car__title" }
const _hoisted_20 = ["href"]
const _hoisted_21 = {
  key: 0,
  class: "c-showroom-2025-car__price"
}
const _hoisted_22 = {
  key: 1,
  class: "c-showroom-2025-car__rebate"
}
const _hoisted_23 = {
  key: 1,
  class: "c-showroom-2025-car__price"
}
const _hoisted_24 = {
  key: 0,
  class: "c-showroom-2025-car__stroke"
}
const _hoisted_25 = {
  key: 1,
  class: "c-showroom-2025-car__rebate"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_svgIco = _resolveComponent("svgIco")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "c-showroom-2025__anchor",
      id: 'marque-'+$props.make
    }, null, 8 /* PROPS */, _hoisted_1),
    _createElementVNode("h2", _hoisted_2, _toDisplayString($props.make), 1 /* TEXT */),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_svgIco, {
        icon: 'marque-'+$props.make
      }, null, 8 /* PROPS */, ["icon"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("button", {
        class: _normalizeClass(["c-showroom-2025-cars-types__item", {'is-active': $data.category=='all'}]),
        onClick: _cache[0] || (_cache[0] = $event => ($data.category = 'all'))
      }, " Voir tout ", 2 /* CLASS */),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.categories, (c, i) => {
        return (_openBlock(), _createElementBlock("button", {
          key: i,
          class: _normalizeClass(["c-showroom-2025-cars-types__item", {'is-active': $data.category==c}]),
          onClick: $event => ($data.category = c)
        }, _toDisplayString(c), 11 /* TEXT, CLASS, PROPS */, _hoisted_5))
      }), 128 /* KEYED_FRAGMENT */))
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _withDirectives(_createElementVNode("select", {
          class: "o-select c-showroom-2025-cars-types__select",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (($data.category) = $event))
        }, [
          _cache[4] || (_cache[4] = _createElementVNode("option", { value: "all" }, "Voir tout", -1 /* HOISTED */)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.categories, (c, i) => {
            return (_openBlock(), _createElementBlock("option", {
              key: i,
              value: c
            }, _toDisplayString(c), 9 /* TEXT, PROPS */, _hoisted_8))
          }), 128 /* KEYED_FRAGMENT */))
        ], 512 /* NEED_PATCH */), [
          [_vModelSelect, $data.category]
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", {
          class: _normalizeClass(["c-showroom-2025-prices-selector__item", {'is-active': $data.price=='cash'}])
        }, [
          _createElementVNode("button", {
            class: "c-showroom-2025-cars-types__btn",
            onClick: _cache[2] || (_cache[2] = $event => ($data.price = 'cash'))
          }, " Prix comptant ")
        ], 2 /* CLASS */),
        _createElementVNode("div", {
          class: _normalizeClass(["c-showroom-2025-prices-selector__item", {'is-active': $data.price=='weekly'}])
        }, [
          _createElementVNode("button", {
            class: "c-showroom-2025-cars-types__btn",
            onClick: _cache[3] || (_cache[3] = $event => ($data.price = 'weekly'))
          }, " Paiement/semaine ")
        ], 2 /* CLASS */)
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.filteredItems, (item, i) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "c-showroom-2025-car",
          key: i
        }, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("a", {
              href: item.url
            }, [
              _createElementVNode("img", {
                src: item.image,
                alt: item.make+' '+item.model
              }, null, 8 /* PROPS */, _hoisted_14)
            ], 8 /* PROPS */, _hoisted_13)
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("a", {
              class: "c-showroom-2025-car__year is-active",
              href: item.url
            }, [
              _createElementVNode("span", null, _toDisplayString(item.annee), 1 /* TEXT */),
              (item.carburants.includes('electric'))
                ? (_openBlock(), _createBlock(_component_svgIco, {
                    key: 0,
                    icon: "2025-electric",
                    class: "c-showroom-2025-car__year__ico"
                  }))
                : _createCommentVNode("v-if", true)
            ], 8 /* PROPS */, _hoisted_16),
            (item.prev)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  class: "c-showroom-2025-car__year",
                  href: item.prev.url
                }, [
                  _createElementVNode("span", null, _toDisplayString(item.prev.annee), 1 /* TEXT */)
                ], 8 /* PROPS */, _hoisted_17))
              : _createCommentVNode("v-if", true)
          ]),
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("h3", _hoisted_19, [
              _createElementVNode("a", {
                href: item.url
              }, _toDisplayString(item.make) + " " + _toDisplayString(item.model), 9 /* TEXT, PROPS */, _hoisted_20)
            ]),
            (item.prix < 300000 && $data.price=='weekly')
              ? (_openBlock(), _createElementBlock("p", _hoisted_21, [
                  _cache[5] || (_cache[5] = _createElementVNode("span", { class: "c-showroom-2025-car__alttext" }, "À partir de", -1 /* HOISTED */)),
                  _createCommentVNode("span class=\"c-showroom-2025-car__stroke\">72,99 $/sem</span"),
                  (item.weekly)
                    ? (_openBlock(), _createElementBlock("strong", {
                        key: 0,
                        class: _normalizeClass({'c-showroom-2025-car__rebate': !item.weekly || !item.weekly.rebate, 'c-showroom-2025-car__strong': item.weekly && item.weekly.rebate})
                      }, _toDisplayString(_ctx.cents(item.weekly.weekly)) + "/sem", 3 /* TEXT, CLASS */))
                    : _createCommentVNode("v-if", true),
                  (item.weekly && item.weekly.rebate)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_22, [
                        _createTextVNode("Rabais de " + _toDisplayString(_ctx.cash(item.weekly.rebate)) + " ", 1 /* TEXT */),
                        _createVNode(_component_svgIco, { icon: "2025-deal" })
                      ]))
                    : _createCommentVNode("v-if", true)
                ]))
              : _createCommentVNode("v-if", true),
            (item.prix < 300000 && $data.price=='cash')
              ? (_openBlock(), _createElementBlock("p", _hoisted_23, [
                  _cache[6] || (_cache[6] = _createElementVNode("span", { class: "c-showroom-2025-car__alttext" }, "À partir de", -1 /* HOISTED */)),
                  (item.rebate)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_24, _toDisplayString(_ctx.cash(item.prix)), 1 /* TEXT */))
                    : _createCommentVNode("v-if", true),
                  _createElementVNode("strong", {
                    class: _normalizeClass({'c-showroom-2025-car__rebate': !item.rebate, 'c-showroom-2025-car__strong': item.rebate})
                  }, _toDisplayString(_ctx.cash(item.prix-item.rebate)), 3 /* TEXT, CLASS */),
                  (item.rebate)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_25, [
                        _createTextVNode("Rabais de " + _toDisplayString(_ctx.cash(item.rebate)) + " ", 1 /* TEXT */),
                        _createVNode(_component_svgIco, { icon: "2025-deal" })
                      ]))
                    : _createCommentVNode("v-if", true)
                ]))
              : _createCommentVNode("v-if", true)
          ])
        ]))
      }), 128 /* KEYED_FRAGMENT */))
    ])
  ], 64 /* STABLE_FRAGMENT */))
}